import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import ChevronRight from 'components/icons/ChevronRight';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

/**
 * Class representing section headings for the site
 */
class ComponentTitle extends Component {
  static propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    link: PropTypes.string,
    linkIconColor: PropTypes.string,
    showArrow: PropTypes.bool,
    // TODO: Deprecate this property in future PR
    classes: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
    titleType: PropTypes.oneOf(Object.values(TITLE_TYPE))
  }

  static defaultProps = {
    title: '',
    color: '',
    link: '',
    linkIconColor: 'rgba(175, 175, 175, 0.5)',
    showArrow: true,
    classes: '',
    target: '_self',
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  render() {
    const { title, color, link, linkIconColor, showArrow, classes, target, titleType } = this.props;
    const className = classNames('ComponentTitle', classes);
    const TitleTag = titleType === TITLE_TYPE.PAGE_TITLE ? 'h1' : 'h2'; // default should be h2 if we get anything but PAGE_TITLE

    if (!title) {
      return null;
    }
    
    const titleHref = link ? (
      
      <a href={link} target={target}>
        <TitleTag className="ComponentTitle-title" style = {{color}}>{title}</TitleTag>
        { showArrow && <div className="ComponentTitle-linkIconContainer">
           <ChevronRight color={linkIconColor} />
          </div> 
        }
      </a>
      ) : (
      <a>
        <TitleTag className="ComponentTitle-title" style = {{color}}>{title}</TitleTag>
        { showArrow && <div className="ComponentTitle-linkIconContainer">
            <ChevronRight color={linkIconColor} />
          </div> 
        }
      </a>
      );

    return (
      <div className={className}>

          {titleHref}
           
      </div>
    );
  }
}

export default ComponentTitle;



// WEBPACK FOOTER //
// ./app/components/shared/ComponentTitle.js